import { permissionReducer } from "../reducer/PermissionReducer";

export const reducer = permissionReducer;
